import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Tag, Alert, Spin } from 'antd';
import { SyncOutlined, WarningTwoTone } from '@ant-design/icons';
import license from '../../Actions/license'
import Base from '../Base';
import TableView from '../tableView';
import { formatMoney } from '../../helpers';
import ProgressBar from '../_Generic/ProgressBar';
import {pageGA } from '../../Helpers/GoogleAnalytics';
import { isPackageExpired } from '../../helpers';
import BillingData from '../UserProfile/BillingData';
import paymentTransaction from '../../Actions/paymentTransaction';
const { getBalanceData, getLicensesHistorical } = license.actions;
const { stampPackageInvoice, showStampInvoiceModal } = paymentTransaction.actions;

class License extends Component {
	constructor(props) {
		super(props);
		this.buyLicense = this.buyLicense.bind(this);
		this.updateLicenseData = this.updateLicenseData.bind(this);
		this.stampPackageInvoice = this.stampPackageInvoice.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.state = {
			confirm: false
		}
	}

	componentDidMount() {		
		pageGA();
	}

	render() {
		const { balance, showStampInvoiceModalStatus } = this.props;
		const { items } = this.props.licensePagination;
		return (
			<Base>
				<h1 className="title-text blue-text">Mi Licencia</h1>
				<p className="label">En este apartado, podrás visualizar las características que tiene tu licencia, vigencia e historial de planes comprados.</p>
				<LicenseInvalid data={balance} />
				<div className="text-center" style={{marginBottom:'25px'}}>
					<Button style={{marginLeft: '15px'}} onClick={this.updateLicenseData}>
						<SyncOutlined /> 
						Refrescar Estatus de la Licencia
					</Button>
				</div>
				<div style={{margin:'0 auto', maxWidth:'900px'}}>
					{
						balance.map((item, key) => {
							return <ProgressBar data={item} key={key} />
						})
					}
					<div style={{marginTop: '45px'}}>
					{
						this.props.licenseStatus === false &&
						<p className="text-center regular-text">
							Actualmente no cuentas con una Licencia activa.
						</p>
					}
						
					</div>	
				</div>	

				<div className="line"></div>
				<h1 className="regular-text">Mis Compras</h1>
				<TableView
					disablePagination={false} 
					loading={this.props.tableLicensesLoading}
					columns={columns}
					data={items}
				/>
				<Modal
					visible={showStampInvoiceModalStatus}
					onCancel={this.closeModal}
					cancelButtonProps={{ style: { display: 'none' } }}
					okButtonProps={{ style: { display: 'none' } }}
					title="Confirma tus datos de facturación"
					bodyStyle={{paddingBottom:0}}
        >
            
			<BillingData stampPackageInvoice={this.stampPackageInvoice} showSaveButton={false} />
			{ this.state.confirm &&
				<div style={{ position:'absolute', top: 0, left: 0, backgroundColor: '#FFF', width:'100%', height: '100%', zIndex: 100, display:'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '35px'}}>					
						<div className="flex-container-align-vertically" style={{marginBottom: '25px'}}>
							<WarningTwoTone color="yellow"  style={{ fontSize: '25px', margin:'0 5px' }}/>
							<h2 className="margin-0">Aviso</h2>
						</div>										
						<p>Si cancela ya no podrá generar su factura de manera automática, aunque tendrá la opción
							de solicitarla al correo de <a href="mailto:soporte@sw.com.mx">soporte@sw.com.mx</a></p>
						<p className="em">¿Está seguro de cancelar?</p>
						<div className="buttons">
							<Button onClick={this.closeModal} style={{marginRight: '5px'}}>No</Button>
							<Button type="primary" onClick={()=> {this.props.showStampInvoiceModal(false)}}>Si</Button>
						</div>
				</div>
			}
			{ this.props.modalLoading &&
				<div className="loading-container loading-absolute loading-100">
					<Spin size="large" tip="Cargando" />
				</div>
			}
        </Modal>
			</Base>
		);
	}

	closeModal() {
		this.setState({confirm: !this.state.confirm});	}

	stampPackageInvoice() {
		const { invoiceInfo } = this.props;
		this.props.stampPackageInvoice(invoiceInfo);
	}

	buyLicense() {
		this.props.history.push(`/buy-license/user/${this.props.email}`);
	}

	updateLicenseData() {
		this.props.getBalanceData();
		this.props.getLicensesHistorical();
	}
}

const columns = [
	{
		title: 'Nombre paquete',
		dataIndex: 'nombrePaquete',
		key: 'nombrePaquete',
	},
	{
		title: 'Fecha compra',
		dataIndex: 'fechaCompra',
		key: 'fechaCompra'
	},
	{
		title: 'Fecha expiración',
		dataIndex: 'fechaExpiracion',
		key: 'fechaExpiracion',
		render: (text, row) => (<span>{row.fechaExpiracion === '01/01/1900' ? 'Cancelado' : row.fechaExpiracion}</span>)
	},
	{
		title: 'Total',
		dataIndex: 'total',
		key: 'total',
		render: (text, row) => (<span>{formatMoney(row.total)}</span>)
	},
	{
		title: 'Estatus',
		dataIndex: 'status',
		key: 'status',
		render: (text, row) => 
		{
			const isExpired =  isPackageExpired(row.fechaExpiracion);
			if (isExpired)
				return <Tag color="red">Expirado</Tag>
			else
				return <Tag color="green">Activo</Tag>
		}	
			
		
	},
];

const LicenseInvalid = ({data}) => {
	if(data.length !== 0) return null;
	return (
		<Alert
			style={{display: 'flex', marginBottom: '20px', alignItems: 'flex-start'}}
			message = { 
				<p>
					Tu plan ha expirado, favor de renovarlo en el botón de cambiar plan.
				</p>
			}
			type="error"		
			closable
		/>
	)
}

const mapStateToProps = state => {
	let tableLicensesLoading = state._genericComponents.loading.find('tableLicensesLoading');
	return {
		licenseStatus: state.license.licenseStatus.isValid,
		licensePagination: state.license.licensePagination,
		balance: state.license.balance, 
		modalLoading: state._genericComponents.loading.find('licenseLoading'),
		showStampInvoiceModalStatus: state.paymentTransaction.showStampInvoiceModal,
		tableLicensesLoading: tableLicensesLoading ? tableLicensesLoading.isLoading : false,
		invoiceInfo: state.license.invoiceData,
		email: Object.keys(state.login.login).length > 0 ? state.login.login.values.username : state.register.registerData.email,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getBalanceData() {
			dispatch(getBalanceData());
		},
		getLicensesHistorical() {
			dispatch(getLicensesHistorical());
		},
		stampPackageInvoice(data) {
			dispatch(stampPackageInvoice(data));
		},
		showStampInvoiceModal(status) {
			dispatch(showStampInvoiceModal(status));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(License);